import { Controller } from 'stimulus'

export default class extends Controller {

  toggle(event) {
    const button = event.currentTarget
    const group  = button.closest('tbody')
    const open   = group.querySelector('tr.realization-detail')

    if (open && open.dataset.key === button.dataset.key) return this.fold(group)

    this.fold(group)
    this.highlight(button)
    this.load(group, button)
  }

  close(event) {
    this.fold(event.currentTarget.closest('tbody'))
  }

  load(group, button) {
    const row  = document.createElement('tr')
    const cell = document.createElement('td')
    row.className   = 'realization-detail'
    row.dataset.key = button.dataset.key
    cell.colSpan    = group.rows[0].cells.length
    cell.innerHTML  = '<div class="px-5 pb-4 pt-1 text-[12.5px] text-slate-400"><i class="fas fa-circle-notch fa-spin mr-2"></i></div>'
    row.appendChild(cell)
    group.appendChild(row)

    fetch(button.dataset.url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(response => response.ok ? response.text() : Promise.reject(response))
      .then(html => { if (row.isConnected) cell.innerHTML = html })
      .catch(() => { if (row.isConnected) this.fold(group) })
  }

  fold(group) {
    group.querySelectorAll('tr.realization-detail').forEach(row => row.remove())
    group.querySelectorAll('.realization-figure').forEach(figure => figure.style.boxShadow = '')
  }

  highlight(button) {
    button.style.boxShadow = '0 0 0 2px #2563eb'
  }
}
